"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    xxxs: '2px',
    xxs: '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '40px',
    xxxl: '48px',
    xxxxl: '64px',
};
exports.default = spacing;
